<script lang="ts">
	import type { DuplicateVinQuery$result } from '$houdini'
	import type { SvelteAsr } from 'types/common'

	import Modal from '@isoftdata/svelte-modal'
	import { Table, Td } from '@isoftdata/svelte-table'

	type DuplicateVinVehicle = DuplicateVinQuery$result['vehicles']['items'][0]

	interface Props {
		show?: boolean
		asr: SvelteAsr
		close?: () => void
		continueWithDuplicateVin: (vin: string) => void
	}

	let { show = $bindable(false), asr, close = () => (show = false), continueWithDuplicateVin }: Props = $props()

	let vin: string = $state('')
	let vehicles: Array<DuplicateVinVehicle> = $state([])

	export async function open(duplicateVinVehicles: Array<DuplicateVinVehicle>, inputVin: string) {
		vehicles = duplicateVinVehicles
		vin = inputVin
		show = true
	}
</script>

<Modal
	{close}
	title="Duplicate VIN Found"
	confirmButtonText="Continue With Duplicate VIN"
	modalSize="lg"
	cancelButtonText="Enter a Different VIN"
	bind:show
	confirm={() => continueWithDuplicateVin(vin)}
>
	<div
		class="alert alert-danger"
		role="alert"
	>
		One or more vehicles with VIN <span class="fw-bold">{vin}</span> were found. Select an existing vehicle to open, or continue
		with the duplicate VIN.
	</div>
	<div style="max-height: 60vh; overflow-y: auto;">
		<Table
			responsive
			columns={[
				{ property: 'stockNumber', name: 'Stock #' },
				{ property: 'store[name]', name: 'Store' },
				{ property: 'enteredDate', name: 'Date Created' },
				{ property: 'status', name: 'Status' },
				{ property: 'userStatus', name: 'User Status' },
				{ property: 'inventoryType[name]', name: 'Unit Type' },
				{ property: 'location', name: 'Location' },
			]}
			rows={vehicles}
		>
			{#snippet children({ row: vehicle })}
				<tr
					class="cursor-pointer"
					onclick={() => {
						asr.go('app.vehicle', { id: vehicle.id })
					}}
				>
					<Td property="stockNumber">
						{vehicle.stockNumber}
					</Td>
					<Td property="store['name']">
						{vehicle.store.name}
					</Td>
					<Td property="enteredDate">
						{vehicle.enteredDate ?? 'Unknown'}
					</Td>
					<Td property="status">
						{vehicle.status}
					</Td>
					<Td property="userStatus">
						{vehicle.userStatus}
					</Td>
					<Td property="inventoryType['name']">
						{vehicle.inventoryType.name}
					</Td>
					<Td property="location">
						{vehicle.location}
					</Td>
				</tr>
			{/snippet}
		</Table>
	</div>
</Modal>
